import { getApplicationAccessLink, APPLICATIONS } from '../../ApplicationUrls';
import { ACTIVE_TAB_MAPPING, CONTENT_ACCESS_TABS } from './config/constants';

type ValueOf<T> = T[keyof T];

export const getActiveTab = (currentUrl: string) => {
  let activeTab;
  if (currentUrl) {
    activeTab = Object.keys(ACTIVE_TAB_MAPPING).find((tab: ValueOf<typeof CONTENT_ACCESS_TABS>) =>
      ACTIVE_TAB_MAPPING[tab].some((app: ValueOf<typeof APPLICATIONS>) =>
        currentUrl.startsWith(getApplicationAccessLink(app))
      )
    );
  }
  return activeTab || CONTENT_ACCESS_TABS.CONTENT;
};
